import { useTranslation } from 'react-i18next';

import type { CollectionStatus } from '@nucleus-commerce/api-client/admin';
import { Badge } from '@nucleus-commerce/ui/components/badge';
import { cn } from '@nucleus-commerce/ui/lib/utils';

const STYLES: Record<CollectionStatus, string> = {
  active: 'bg-success/15 text-success border-transparent dark:bg-success/20',
  hidden: 'border-border text-muted-foreground',
};

/** Green for browsable, outlined for hidden. */
export function CollectionStatusBadge({
  status,
  className,
}: {
  status: CollectionStatus;
  className?: string;
}) {
  const { t } = useTranslation('collections');
  return (
    <Badge variant="outline" className={cn(STYLES[status], className)}>
      {t(`status.${status}`)}
    </Badge>
  );
}
